// extracted by mini-css-extract-plugin
export default {"root":"landingWelcome_root__dW5Hj","left_bottom":"landingWelcome_left_bottom__OPTqY"};